module.exports = __webpack_public_path__ + "Proxima Nova Bold.206d2d8a2c115d5c3f35.eot";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Bold.eot
// module id = ../../../../../fonts/Proxima Nova Bold.eot
// module chunks = 2